export const FEE_REQUEST_PAID = 'PAID';
export const FEE_REQUEST_UNPAID = 'UNPD';
export const FEE_REQUEST_CANCELLED = 'CNCL';

export const FEE_REQUEST_UNPAID_DESC = 'Unpaid';
export const FEE_REQUEST_PART_PAID_DESC = 'Partially Paid';
export const FEE_REQUEST_CANCELLED_DESC = 'Cancelled';
